<script>
import { required, between } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { authFackMethods, notificationMethods } from "@/state/helpers";
// eslint-disable-next-line no-unused-vars
import socket from "../../../socket";
/**
 * Register component
 */
export default {
  data() {
    return {
      username: "",
      phone: "",
      type: false,
      submitted: false,
    };
  },
  validations: {
    username: { required },
    phone: { required, between: between(500000000, 599999999) },
  },

  created() {
    socket.on("connect_error", (err) => {
      if (err.message === "invalid username") {
        this.usernameAlreadySelected = false;
      }
    });
  },

  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    notificationAutoCloseDuration() {
      return this.$store && this.$store.state.notification ? 5 : 0;
    },
  },
  methods: {
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          this.startLogin = true;

          const username = this.username;
          const phone = this.phone;
          const type = "abraka";

          socket.auth = { username, type, phone };
          socket.connect();

          socket.emit("callme", username, phone, (response) => {
            if (response.status == 0) {
              this.username = "";
              this.phone = "";
              Swal.fire({
                position: "center",
                icon: "success",
                title: "საკონტაქტო ინფრომაცია გაიგზავნა წარმატებით",
                class: "imedil_h",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });

          //   this.login({ email, password });
        }
        // const { username, type, phone } = this;
        //  socket.auth = { username:"levani", type: false, phone:"44332433" };
        //  socket.connect();
        // this.$router.push({ name: 'chat' })
      }
    },
  },
};
</script>

<template>
  <div class="account-pages pt-2 pt-md-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="text-center mb-0 mb-md-4">
            <router-link to="/" class="auth-logo mb-4 mb-md-5 d-block">
              <img
                src="@/assets/images/logo.png"
                alt
                height="55"
                class="logo logo-dark"
              />
              <img
                src="@/assets/images/logo.png"
                alt
                height="55"
                class="logo logo-light"
              />
            </router-link>
          </div>
          <div class="card">
            <div class="card-head pt-3 pl-3">
              <div class="col-12 pl-md-3">
                <h4 class="imedil_h text-center text-info">გამარჯობა</h4>
              </div>
            </div>
            <div class="card-body p-md-3">
              <b-alert
                :variant="notification.type"
                class="mt-3"
                v-if="notification.message"
                :show="notificationAutoCloseDuration"
                dismissible
                >{{ notification.message }}</b-alert
              >
              <div class="p-3">
                <form @submit.prevent="tryToLogIn">
                  <div class="form-group">
                    <label class="imedil_t">სახელი</label>
                    <div
                      class="
                        input-group
                        mb-3
                        bg-soft-light
                        input-group-lg
                        rounded-lg
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text border-light text-muted">
                          <i class="ri-user-line"></i>
                        </span>
                      </div>
                      <input
                        v-model="username"
                        type="text"
                        class="form-control bg-soft-light border-light"
                        :class="{
                          'is-invalid': submitted && $v.username.$error,
                        }"
                        placeholder="შეიყვანე სახელი"
                      />
                      <div
                        v-if="submitted && $v.username.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.username.required"
                          >სახელი აუცილებელია</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="form-group mt-4">
                    <label class="imedil_t">მობილური ტელეფონის ნომერი</label>
                    <div
                      class="
                        input-group
                        mb-3
                        bg-soft-light
                        input-group-lg
                        rounded-lg
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text border-light text-muted">
                          <i class="ri-phone-line"></i>
                        </span>
                      </div>
                      <input
                        v-model="phone"
                        type="text"
                        class="form-control bg-soft-light border-light"
                        placeholder="5XXXXXXXX"
                        :class="{ 'is-invalid': submitted && $v.phone.$error }"
                      />
                      <div
                        v-if="submitted && $v.phone.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.phone.required"
                          >ტელეფონის ნომერი აუცილებელია</span
                        >
                        <span v-if="!$v.phone.between"
                          >შეიყვანეთ სწორი ტელეფონის ნომერი მაგ: 5XXXXXXXX</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-6 m-auto">
                    <button class="btn btn-info btn-block" type="submit">
                      გაგზავნა
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="mt-1 mt-md-3 text-center imedil_t">
            <div class="alert alert-danger">
              * ონლაინ ჩათით სარგებლობა შესაძლებელია 10:00-19:00-მდე.
              <br /><br />
              * სურვილის შემთხვევში დაგვიტოვე საკონტაქტო ინფორმაცია და ჩვენ
              თავად დაგიკავშირდებით სამუშაო საათების განახლებისას.
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center BPGArial font-size-14 pt-3">
      <!-- {{new Date().getFullYear() }} -->
      Powered by <img src="@/assets/images/cq_logo.png" alt height="16" />
    </p>
  </div>
</template>
<style>
.swal2-container.swal2-center > .swal2-popup {
  font-size: 11px;
}
.swal2-title {
  font-size: 18px !important;
  font-family: "ImediFLT" !important;
}
</style>